import React from "react";
import __ from "lodash";

class DropdownSubTipeToo extends React.Component {
  render() {
    return (
      <>
        <option key={"TOO"} value={"TOO"}>
          TRYOUT
        </option>
        <option key={"AGCU"} value={"AGCU"}>
          AGCU
        </option>
        <option key={"UNBK"} value={"UNBK"}>
          UNBK
        </option>
        <option key={"UTBK"} value={"UTBK"}>
          UTBK
        </option>
        <option key={"SBMPTN"} value={"SBMPTN"}>
          SBMPTN
        </option>
        <option key={"USS1"} value={"USS1"}>
          USS1
        </option>
        <option key={"USS2"} value={"USS2"}>
          USS2
        </option>
        <option key={"USS3"} value={"USS3"}>
          USS3
        </option>
        <option key={"AKM"} value={"AKM"}>
          AKM
        </option>
        <option key={"PEMINATAN"} value={"PEMINATAN"}>
          PEMINATAN
        </option>
        <option key={"PEMETAAN"} value={"PEMETAAN"}>
          PEMETAAN
        </option>
        <option key={"PEMETAAN2"} value={"PEMETAAN2"}>
          PEMETAAN 2
        </option>
        <option key={"PEMETAAN3"} value={"PEMETAAN3"}>
          PEMETAAN 3
        </option>
        <option key={"ENSA"} value={"ENSA"}>
          ENSA
        </option>
      </>
    );
  }
}

export default DropdownSubTipeToo;
